import PropTypes from 'prop-types';
import React from 'react';
import { IndexLink, Link } from 'react-router';


require('./style.scss');

const SVG_FILE_PATH = '../../../static/images/';
const getAbsoluteUrl = (partnerSlug, url) => `/${partnerSlug}${url}`;

const Menu = props =>
  <nav id="site-nav">
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-18">
          <div className="menu-nav-wrapper">
            <ul className="menu-nav">
              <li>
                <IndexLink
                  to={getAbsoluteUrl(props.partnerSlug, '/')}
                  activeClassName="active"
                  onlyActiveOnIndex
                >
                  <img alt="h" src={`${SVG_FILE_PATH}home.svg`} /> Home
                </IndexLink>
              </li>
              <li>
                <Link to={getAbsoluteUrl(props.partnerSlug, '/offers')} activeClassName="active">
                  <img alt="h" src={`${SVG_FILE_PATH}store-offers.svg`} /> Store Offers
                </Link>
              </li>

              <li>
                <Link to={getAbsoluteUrl(props.partnerSlug, '/products')} activeClassName="active">
                  <img alt="h" src={`${SVG_FILE_PATH}store-exclusive.svg`} /> Store Products
                </Link>
              </li>

              <li>
                <Link to={getAbsoluteUrl(props.partnerSlug, '/reviews')} activeClassName="active">
                  <img alt="h" src={`${SVG_FILE_PATH}review.svg`} /> Reviews
                </Link>
              </li>

              <li>
                <Link to={getAbsoluteUrl(props.partnerSlug, '/photos')} activeClassName="active">
                  <img alt="h" src={`${SVG_FILE_PATH}store-image.svg`} /> Photos
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {props.facebookPageId ?
          <div className="col-md-6 text-right visible-md visible-lg">
            <iframe
              src={`https://www.facebook.com/plugins/like.php?href=https://facebook.com/${props.facebookPageId}&width=200&layout=button_count&action=like&size=large&show_faces=false&share=true&height=80&appId`}
              width="140"
              height="42"
              style={{ border: 'none', overflow: 'hidden', padding: '10px 0 4px 0' }}
              scrolling="no"
              frameBorder="0"
              allowTransparency="true"
            />
          </div> : null}
      </div>
    </div>
  </nav>;

Menu.propTypes = {
  facebookPageId: PropTypes.string,
  partnerSlug: PropTypes.string,
};

module.exports = Menu;



// WEBPACK FOOTER //
// ./app/layouts/menu/Menu.jsx